import BaseModel from './base-model';
/**
 * format:
 * {@id: "2307", @REL_ATTR: "2307", @COMMON_NAME: "Analyst", link: {…}}
 */

export default class UserType extends BaseModel {
  constructor(opts = {}) {
    super(opts);
  }
}
